import { Icon } from "lucide-react";
const TabButton = ({ active, onClick, icon: Icon, label, disabled , className }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={` flex items-center justify-center gap-2 px-3 md:px-6 py-2.5 rounded-xl text-[10px] md:text-xs font-black uppercase tracking-widest transition-all duration-300 flex-1 md:flex-none
      ${active ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/20' : 'text-gray-500 hover:text-white hover:bg-white/5'}
      ${disabled ? 'opacity-30 cursor-not-allowed' : ''} ${className}
    `}
  >
    <Icon size={14} /> <span className={active ? 'inline' : 'hidden md:inline'}>{label}</span>
  </button>
);

export default TabButton


